import { cn } from "@/lib/utils";

interface SegmentedControlProps {
  value: string;
  onValueChange: (value: string) => void;
  options: { value: string; label: string }[];
  className?: string;
}

export function SegmentedControl({
  value,
  onValueChange,
  options,
  className,
}: SegmentedControlProps) {
  return (
    <div
      className={cn(
        "inline-flex w-full bg-copilot-surface-sunken rounded-[10px] p-[3px] gap-0.5",
        className
      )}
      role="tablist"
    >
      {options.map((option) => (
        <button
          key={option.value}
          role="tab"
          aria-selected={value === option.value}
          onClick={() => onValueChange(option.value)}
          className={cn(
            "flex-1 min-h-[var(--touch-target)] flex items-center justify-center rounded-lg",
            "text-sm font-medium text-copilot-text-secondary cursor-pointer",
            "transition-all px-2 whitespace-nowrap border-none bg-transparent",
            value === option.value &&
              "bg-white text-copilot-text-primary font-semibold shadow-sm"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
